import Head from 'next/head';
import { organizationData } from '../data/SchemaTag'
const SeoHead = ({ title, description, image = "/og-image.png", jsonLd, url }) => {

  return (
    <Head>
      <title>{title || 'Millance'}</title>
      <link rel="icon" href="/favicon.ico" />
      <meta name="description" content={description || 'Trade Smarter with Millance – Your Forex Partner'} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      <meta property="og:title" content={title || 'Millance'} />
      <meta property="og:description" content={description || 'Millance offers secure, AI-powered forex trading solutions, educational tools, and top-tier support for traders of all experience levels.'} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={jsonLd?.image} />
      {url && <meta property="og:url" content={url} />}


      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || 'Millance'} />
      <meta name="twitter:description" content={description || 'Trade Smarter with Millance – Your Forex Partner'} />
      <meta name="twitter:image" content={jsonLd?.image} />
      <meta name="twitter:image:alt" content={description || 'Trade Smarter with Millance – Your Forex Partner'} />
      <meta property="twitter:url" content={url} />




      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow" />


      <script async src="https://www.googletagmanager.com/gtag/js?id=G-DQJ0GBK88J" />
      <script dangerouslySetInnerHTML={{
        __html: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'G-DQJ0GBK88J');
                  `,
      }}
      />
      <script
        src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.7/dist/js/bootstrap.bundle.min.js"
        defer
      />



      {/* === FingerprintJS & jQuery === */}
      <script
        src="https://cdnjs.cloudflare.com/ajax/libs/fingerprintjs2/1.5.1/fingerprint2.min.js"
        defer
      ></script>
      <script
        src="https://code.jquery.com/jquery-3.6.0.min.js"
        defer
      ></script>
      {/* <div className="chatbot" /> */}

      {/* === SmatBot Script === */}
      {/* <script
        dangerouslySetInnerHTML={{
          __html: `
              var chatbot_id = 25090;
              !(function () {
                var t, e, a = document, s = "smatbot-chatbot";
                if (!a.getElementById(s)) {
                  t = a.createElement("script");
                  t.id = s;
                  t.type = "text/javascript";
                  t.src = "https://smatbot.s3.amazonaws.com/files/smatbot_plugin.js.gz";
                  e = a.getElementsByTagName("script")[0];
                  e.parentNode.insertBefore(t, e);
                }
              })();
            `,
        }}
      /> */}
      {organizationData && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationData) }} />
      )}
      {jsonLd && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      )}

    </Head>
  );
};

export default SeoHead;
